import { useStore } from 'effector-react';
import { $tags, $sharedTags, $tagsLoading, getTags } from './tag';

export const useTags = () => ({
  tags: useStore($tags),
  sharedTags: useStore($sharedTags),
  loading: useStore($tagsLoading),
  getTags,
});
